var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23F7DD",
    d: "m12.857 12l6-3.212l-1.03-1.93l-5.603 2.1a.6.6 0 0 1-.449 0l-5.602-2.1l-1.03 1.936l6 3.206l-6 3.206l1.03 1.937l5.602-2.1a.6.6 0 0 1 .449 0l5.603 2.1l1.03-1.948z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgld);
export default __webpack_public_path__ + "static/media/egld.91910cbed033be68cc2d344e26222a77.svg";
export { ForwardRef as ReactComponent };